// extracted by mini-css-extract-plugin
module.exports = {"slide-move":"_Transition_slide-move_3XOod","slideXLeftIn":"_Transition_slideXLeftIn_15J_T","slideXLeftOut":"_Transition_slideXLeftOut_2tkwQ"};